var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullScreenActive = function SvgFullScreenActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#325A6D",
    fillRule: "evenodd",
    d: "M5.1 8.9a.44.44 0 0 0-.618 0L.897 12.484v-2.421a.438.438 0 1 0-.875 0v3.477c0 .242.196.438.438.438h3.478a.438.438 0 0 0 0-.875H1.516L5.1 9.519a.44.44 0 0 0 0-.619M8.9 8.9c.171-.17.448-.17.62 0l3.584 3.584v-2.421a.438.438 0 0 1 .875 0v3.477a.44.44 0 0 1-.438.438h-3.478a.438.438 0 0 1 0-.875h2.422L8.9 9.519a.437.437 0 0 1 0-.619M8.9 5.1c.17.17.448.17.618 0l3.584-3.584v2.422a.438.438 0 0 0 .875 0V.459a.437.437 0 0 0-.437-.437h-3.478a.438.438 0 1 0 0 .875h2.422L8.9 4.481a.44.44 0 0 0 0 .619M5.1 5.1a.44.44 0 0 1-.618 0L.897 1.516v2.422a.438.438 0 0 1-.875 0V.459C.022.218.218.022.46.022h3.478a.437.437 0 1 1 0 .875H1.516L5.1 4.481c.171.171.171.448 0 .619",
    clipRule: "evenodd"
  })));
};
export default SvgFullScreenActive;